/**
 * Free Tier Users — Standalone Page
 * Wraps FreeTierMembersTab for direct route access
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { PersonOff as PersonOffIcon } from '@mui/icons-material';
import FreeTierMembersTab from './FreeTierMembersTab';
import { spacing } from '../../theme/designTokens';

const FreeTierStandalonePage: React.FC = () => {
  return (
    <Box sx={{ p: spacing[6], bgcolor: 'background.default', minHeight: '100vh' }}>
      <Box sx={{ mb: spacing[8] }}>
        <Typography variant="h1" sx={{ fontWeight: 700, display: 'flex', alignItems: 'center', gap: spacing[3], mb: spacing[2] }}>
          <PersonOffIcon color="warning" sx={{ fontSize: 40 }} />
          Free Tier Users
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ fontSize: '1.125rem' }}>
          Conversion intelligence, behavioral scoring, and audience targeting for free tier members
        </Typography>
      </Box>
      <FreeTierMembersTab />
    </Box>
  );
};

export default FreeTierStandalonePage;
